import { SVGProps, Ref, forwardRef } from 'react';

export const FacebookGrayscaleSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M13.454 23.913C19.396 23.195 24 18.135 24 12c0-6.627-5.373-12-12-12S0 5.373 0 12c0 5.628 3.874 10.35 9.1 11.647v-7.98H6.625V12h2.477v-1.584c0-4.085 1.848-5.976 5.856-5.976.758 0 2.069.149 2.606.298v3.326a16 16 0 0 0-1.387-.043c-1.968 0-2.726.744-2.726 2.683V12h3.921l-.672 3.667h-3.245z"
                    fill="#919191"
                />
                <path
                    d="M9.1 23.647v-7.98H6.625V12h2.477v-1.584c0-4.085 1.848-5.976 5.856-5.976.758 0 2.069.149 2.606.298v3.326a16 16 0 0 0-1.387-.043c-1.968 0-2.726.744-2.726 2.683V12h3.921l-.672 3.667h-3.245v8.246a12.1 12.1 0 0 1-4.353-.266"
                    fill="#E2E2E2"
                />
            </g>
        </g>
    </svg>
));
FacebookGrayscaleSize24Glyph.displayName = 'FacebookGrayscaleSize24Glyph';
